<script setup lang="ts">
import { useI18n } from "vue-i18n";

import { useResetTradeIn } from "@/features/reset-trade-in/model";
import { SuccessIcon, UiButton, UiStepLayout } from "@/shared/ui";

const { t } = useI18n({ useScope: "global" });
const { restart: sendAnother, close } = useResetTradeIn();
</script>

<!-- Заявка на выкуп отправлена, последний экран -->
<template>
    <UiStepLayout>
        <div class="thanks">
            <SuccessIcon class="thanks__icon" />
            <h2 class="thanks__title">{{ t("thanksForOrder.title") }}</h2>
            <p class="thanks__text">{{ t("thanksForOrder.text") }}</p>

            <div class="thanks__actions">
                <UiButton @click="close">{{ t("common.close") }}</UiButton>
                <UiButton color="light" @click="sendAnother">
                    {{ t("thanksForOrder.sendAnother") }}
                </UiButton>
            </div>
        </div>
    </UiStepLayout>
</template>

<style scoped>
.thanks {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 24px;
    padding-bottom: 8px;
    text-align: center;
    user-select: none;
}

.thanks__icon {
    margin-bottom: 32px;
}

.thanks__title {
    margin: 0 0 8px;
    font-size: calc(var(--custom-font-size) * 1.429);
    font-weight: 700;
    line-height: 1.2;
}

.thanks__text {
    max-width: 300px;
    margin: 0 0 24px;
    font-size: var(--custom-font-size);
    line-height: 1.429;
}

.thanks__actions {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
}
</style>
